import config from "../config";

/**
 * Turn a stored logoUrl into a usable URL for <img src>, fetch, etc.
 * - Empty/null → null
 * - Already absolute (http/https/data:) → returned as-is
 * - Relative → prefixed with the backend API base, ensuring exactly one slash
 */
export const resolveLogoUrl = (logoUrl) => {
  if (!logoUrl) return null;

  const trimmed = String(logoUrl).trim();
  if (!trimmed) return null;

  if (/^(https?:|data:)/i.test(trimmed)) {
    return trimmed;
  }

  const base = (config.SPRING_API_BASE || "").replace(/\/+$/, "");
  const path = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
  return `${base}${path}`;
};

export default resolveLogoUrl;
